module.exports = __webpack_public_path__ + "img/check.9fb5ca86.svg";